import { render, staticRenderFns } from "./vBottomPop.vue?vue&type=template&id=025a8070&scoped=true"
import script from "./vBottomPop.vue?vue&type=script&lang=ts"
export * from "./vBottomPop.vue?vue&type=script&lang=ts"
import style0 from "./vBottomPop.vue?vue&type=style&index=0&id=025a8070&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025a8070",
  null
  
)

export default component.exports